import { render, staticRenderFns } from "./CustomerMarquee.vue?vue&type=template&id=bf1f2136&"
import script from "./CustomerMarquee.vue?vue&type=script&lang=ts&"
export * from "./CustomerMarquee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports